// extracted by mini-css-extract-plugin
export default {"sticky":"sticky_sticky__a7e0r"};